export * from "ce/IDE/hooks/useParentEntityInfo";

import { ActionParentEntityType } from "ee/entities/Engine/actionHelpers";
import { IDE_TYPE, type IDEType } from "ee/IDE/Interfaces/IDETypes";
import { getCurrentBaseModuleId } from "ee/selectors/modulesSelector";
import { getCurrentBasePackageId } from "ee/selectors/packageSelectors";
import { getCurrentWorkflowId } from "ee/selectors/workflowSelectors";
import { useSelector } from "react-redux";
import {
  getCurrentApplicationId,
  getCurrentBasePageId,
} from "selectors/editorSelectors";

export const useParentEntityInfo = (ideType: IDEType) => {
  const appId = useSelector(getCurrentApplicationId);
  const basePageId = useSelector(getCurrentBasePageId);
  const packageId = useSelector(getCurrentBasePackageId);
  const moduleId = useSelector(getCurrentBaseModuleId);
  const workflowId = useSelector(getCurrentWorkflowId);

  switch (ideType) {
    case IDE_TYPE.Package:
    case IDE_TYPE.UIPackage:
      return {
        editorId: packageId || "",
        parentEntityId: moduleId || "",
        parentEntityType: ActionParentEntityType.MODULE,
      };
    case IDE_TYPE.Workflow:
      return {
        editorId: workflowId || "",
        parentEntityId: workflowId || "",
        parentEntityType: ActionParentEntityType.WORKFLOW,
      };
    default:
      return {
        editorId: appId || "",
        parentEntityId: basePageId || "",
        parentEntityType: ActionParentEntityType.PAGE,
      };
  }
};
